import React, { useEffect } from 'react';
import LogoImage from '../../assets/images/mpower-logo.png';
import './SuccessPage.scss'
import AuthUtils from '../../utils/AuthUtils';
import { useDispatch,useSelector } from 'react-redux';
import { _logout, _patientLogout } from '../../../../shared/src/store/actions/AuthActions';
import { useTranslation } from 'react-i18next';
const SuccessPage = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const files = useSelector((state:any)=>state.patientInfo)
    useEffect(() => {
        AuthUtils.clearAuthToken();
        AuthUtils.clearPatientAuthToken()
        dispatch(_logout());
        dispatch(_patientLogout());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const filesString = files.uploadedFiles[0].length >1?files.uploadedFiles[0].join(' and '):files.uploadedFiles[0].join('')
    return (
        <div className="patient-portal-success-wrapper">
            <div className="logo-wrapper">
                <img src={LogoImage} />
            </div>
            <p className="success-text">{t('PATIENT_DOCUMENT_UPLOAD.SUBMITEDMESSAGE', {filesString})}</p>
            <p className='body-text'>{t('PATIENT_DOCUMENT_UPLOAD.THANKINGMESSAGE', {filesString})}</p>
            <p className='close-text'>{t('PATIENT_DOCUMENT_UPLOAD.WINDOWCLOSE')}</p>
        </div>
    )
}

export default SuccessPage;